import { Model } from '../parents/model';

export class ProductImageModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_DESCRIPTION = 'description';
  static ATTR_PRODUCT_ID = 'product_id';
  static ATTR_IMAGE_ID = 'image_id';
  static ATTR_POSITION = 'position';
  static ATTR_IS_DEFAULT = 'is_default';
  static ATTR_UPDATED_AT = 'updated_at';
  static ATTR_CREATED_AT = 'created_at';

  get description() {
    return this.attributes[ProductImageModel.ATTR_DESCRIPTION];
  }

  get productId() {
    return this.attributes[ProductImageModel.ATTR_PRODUCT_ID];
  }

  get imageId() {
    return this.attributes[ProductImageModel.ATTR_IMAGE_ID];
  }

  get position() {
    return this.attributes[ProductImageModel.ATTR_POSITION];
  }

  get isDefault() {
    return this.attributes[ProductImageModel.ATTR_IS_DEFAULT];
  }

  get updatedAt() {
    return this.attributes[ProductImageModel.ATTR_UPDATED_AT];
  }

  get createdAt() {
    return this.attributes[ProductImageModel.ATTR_CREATED_AT];
  }
}
